<template>
	<ion-app>
		<ion-tabs>
			<ion-router-outlet />

			<ion-tab-bar slot="bottom">
				<ion-tab-button tab="home" href="/home">
					<ion-icon :icon="homeOutline" />
					<ion-label>Aufträge</ion-label>
				</ion-tab-button>

				<ion-tab-button tab="calendar" href="/calendar">
					<ion-icon :icon="calendarOutline" />
					<ion-label>Kalender</ion-label>
				</ion-tab-button>

				<ion-tab-button tab="map" href="/map">
					<ion-icon :icon="mapOutline" />
					<ion-label>Karte</ion-label>
				</ion-tab-button>
			</ion-tab-bar>
		</ion-tabs>
	</ion-app>
</template>

<script>
import {
	IonApp,
	IonRouterOutlet,
	IonTabs,
	IonTabBar,
	IonTabButton,
	IonLabel,
	IonIcon
} from '@ionic/vue';
import { defineComponent } from 'vue';
import { homeOutline, calendarOutline, mapOutline } from 'ionicons/icons';

export default defineComponent({
	name: 'App',
	components: {
		IonApp,
		IonRouterOutlet,
		IonTabs,
		IonTabBar,
		IonTabButton,
		IonLabel,
		IonIcon
	},
	setup() {
		return {
			homeOutline,
			calendarOutline,
			mapOutline
		};
	}
});
</script>
